export {
  trpc,
  type RouterInputs,
  type RouterOutputs,
  type ReactQueryOptions,
} from "../../data/core/trpc";
